function DropUp(props) {
  return (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 7.68359L8 0.683594L15.5 7.6836" stroke="#6D7887" stroke-linecap="round" />
    </svg>

  )
}

export default DropUp
